import {
    checkStatusValidation,
    createBookRemuneration,
} from "@/api/s3BookRemunerations";
import {
    checkStatusFilesValidation,
    uploadFiles,
} from "@/api/uploadFiles";
import WebSocket from "@/utils/baseWebSocket";

export default {
    state: () => ({
        webSocketRemunerations: {
            responseMessage: {
                complete_transaction: false,
                errors: "",
            },
        },
        webSocketOtherRemunerations: {
            responseMessage: {
                complete_transaction: false,
                errors: "",
            },
        },
        webSocketRemuneraciones:    {
            responseMessage: {
                complete_transaction: false,
                errors: "",
                kind_file: 'remuneraciones'
            },
        }, 
        webSocketFacturasExtranjeras: {
            responseMessage: {
                complete_transaction: false,
                errors: "",
                kind_file: 'facturas_extranjeras'
            },
        },
        webSocketRecibos: {
            responseMessage: {
                complete_transaction: false,
                errors: "",
                kind_file: 'recibos'
            },
        }, 
        webSocketFiniquitos:{
            responseMessage: {
                complete_transaction: false,
                errors: "",
                kind_file:'finiquitos'
            },
        },
        webSocketExportableErp: {
            responseMessage: {
                complete_transaction: false,
                errors: "",
                kind_file:'exportable_erp'
            },
        },
        webSocketCreditos: {
            responseMessage: {
                complete_transaction: false,
                errors: "",
                kind_file:'creditos'
            },
        },
        webSocketBalance8Columnas: {
            responseMessage: {
                complete_transaction: false,
                errors: "",
                kind_file:'balance_8_columnas'
            },
        }, 
        webSocketLibroBancos:{
            responseMessage: {
                complete_transaction: false,
                errors: "",
                kind_file:'libro_bancos'
            },
        }, 
        webSocketDataOperacionalComplementaria: {
            responseMessage: {
                complete_transaction: false,
                errors: "",
                kind_file:'data_operacional_complementaria'
            },
        },
    }),
    mutations: {
        SET_WEBSOCKET: (state, payload) => {
            if (payload.responseMessage.kind_file == "remuneration") {
                state.webSocketRemunerations = payload;
            } else if(payload.responseMessage.kind_file == "other_obligations"){
                state.webSocketOtherRemunerations = payload;
            } else if(payload.responseMessage.kind_file == "remuneraciones"){
                state.webSocketRemuneraciones = payload
            } else if(payload.responseMessage.kind_file == "facturas_extranjeras"){
                state.webSocketFacturasExtranjeras = payload
            } else if(payload.responseMessage.kind_file == "recibos"){
                state.webSocketRecibos = payload
            } else if(payload.responseMessage.kind_file == "finiquitos"){
                state.webSocketFiniquitos = payload
            } else if(payload.responseMessage.kind_file == "exportable_erp"){
                state.webSocketExportableErp = payload
            } else if(payload.responseMessage.kind_file == "creditos"){
                state.webSocketCreditos = payload
            } else if(payload.responseMessage.kind_file == "balance_8_columnas"){
                state.webSocketBalance8Columnas = payload
            } else if(payload.responseMessage.kind_file == "libro_bancos"){
                state.webSocketLibroBancos = payload
            } else if(payload.responseMessage.kind_file == "data_operacional_complementaria"){
                state.webSocketDataOperacionalComplementaria = payload
            } 
        },
        SET_TRANSACTION: (state, payload) => {
            if (payload.kind_file == "remuneration"){
                state.webSocketRemunerations.responseMessage.complete_transaction =
                    payload.complete_transaction;
            } else if(payload.kind_file == "other_obligations"){
                state.webSocketOtherRemunerations.responseMessage.complete_transaction =
                    payload.complete_transaction;
            }
        },
        SET_STATUS_FOR_FILES: (state, newStatus) => {
            if(state.webSocketRemunerations.responseMessage.status == 'SUBIDO_EXITOSAMENTE') {
                state.webSocketRemunerations.responseMessage.complete_transaction = newStatus
            }
            if(state.webSocketOtherRemunerations.responseMessage.status == 'SUBIDO_EXITOSAMENTE') {
                state.webSocketOtherRemunerations.responseMessage.complete_transaction = newStatus
            }
            if(state.webSocketRemuneraciones.responseMessage.status == 'SUBIDO_EXITOSAMENTE') {
                state.webSocketRemuneraciones.responseMessage.complete_transaction = newStatus
            }
            if(state.webSocketFacturasExtranjeras.responseMessage.status == 'SUBIDO_EXITOSAMENTE') {
                state.webSocketFacturasExtranjeras.responseMessage.complete_transaction = newStatus
            }
            if(state.webSocketRecibos.responseMessage.status == 'SUBIDO_EXITOSAMENTE') {
                state.webSocketRecibos.responseMessage.complete_transaction = newStatus
            }
            if(state.webSocketFiniquitos.responseMessage.status == 'SUBIDO_EXITOSAMENTE') {
                state.webSocketFiniquitos.responseMessage.complete_transaction = newStatus
            }
            if(state.webSocketExportableErp.responseMessage.status == 'SUBIDO_EXITOSAMENTE') {
                state.webSocketExportableErp.responseMessage.complete_transaction = newStatus
            }
            if(state.webSocketCreditos.responseMessage.status == 'SUBIDO_EXITOSAMENTE') {
                state.webSocketCreditos.responseMessage.complete_transaction = newStatus
            }
            if(state.webSocketBalance8Columnas.responseMessage.status == 'SUBIDO_EXITOSAMENTE') {
                state.webSocketBalance8Columnas.responseMessage.complete_transaction = newStatus
            }
            if(state.webSocketLibroBancos.responseMessage.status == 'SUBIDO_EXITOSAMENTE') {
                state.webSocketLibroBancos.responseMessage.complete_transaction = newStatus
            }
            if(state.webSocketDataOperacionalComplementaria.responseMessage.status == 'SUBIDO_EXITOSAMENTE') {
                state.webSocketDataOperacionalComplementaria.responseMessage.complete_transaction = newStatus
            }
        },
    },
    actions: {
        callCreateBookRemuneration({ commit, dispatch }, payload) {
            return new Promise((resolve, reject) => {
                let kind_file = payload.get("kind_file")
                let requestToUpload = null
                if(kind_file == "remuneration" || kind_file == "other_obligations" ){
                    requestToUpload = createBookRemuneration
                } else {
                    requestToUpload = uploadFiles
                }
                commit("SET_STATUS_FOR_FILES", false);
                requestToUpload(payload)
                    .then((response) => {
                        const initialPayload = {
                            responseMessage: {
                                complete_transaction: false,
                                ...response.data,
                            },
                        };
                        commit("SET_WEBSOCKET", initialPayload);
                        dispatch("startWebSocket", kind_file);
                        resolve(true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        startWebSocket({ commit }, payload) {
            let webSocket = WebSocket;
            let checkValidation = null
            if(payload == "remuneration" || payload == "other_obligations" ){
                checkValidation = checkStatusValidation
            } else {
                checkValidation = checkStatusFilesValidation
            }
            webSocket.connect(checkValidation, payload);
            webSocket.responseMessage.kind_file = payload;
            commit("SET_WEBSOCKET", webSocket);
        },
    },
    getters: {},
    namespaced: true,
};
